import React from 'react';
import Icon from '../muiComponents/Icon';
import Tooltip from '../muiComponents/Tooltip';

const InfoIcon = ({ tooltipText }: { tooltipText: string }) => {
    return (
        <Tooltip titleText={tooltipText}>
            <span>
                <Icon
                    iconName='InfoOutlined'
                    style={{
                        fontSize: '12px',
                        color: 'var(--grey-400)',
                        marginBottom: '4px',
                        cursor: 'pointer',
                    }}
                />
            </span>
        </Tooltip>
    );
};

export default InfoIcon;
